import Vue from 'vue'
import Vuex from 'vuex'
import VueCookie from 'vue-cookie'
import VueResource from 'vue-resource'
import router from './views'
import store from './store'
import Cover from 'vendors/cover/cover.js'
import 'vendors/cover/cover.css'
import 'vendors/cover/vendors/multiselect/style.css'
import 'vendors/cover/vendors/flatpickr/style.css'
import Flatpickr from 'vendors/cover/vendors/flatpickr'
import Chart from 'vendors/cover/vendors/chart'
import VueTextareaAutosize from 'vue-textarea-autosize'
import * as VueGoogleMaps from 'vue2-google-maps'
import env from '../config/prod.env.js'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import socketio from 'socket.io-client'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vuetify from 'vuetify'
import HorizontalStepper from 'vue-stepper'
import Vuelidate from 'vuelidate'
import BTooltip from 'bootstrap-vue/es/components/tooltip/tooltip'
import VueAppend from 'vue-append'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VuejsDialog from 'vuejs-dialog'
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import SlidingPagination from 'vue-sliding-pagination'
import "vue-sliding-pagination/dist/style/vue-sliding-pagination.css"


// register globally
Vue.component('c-flatpickr', Flatpickr)
Vue.component('c-chart', Chart)
Vue.component('multiselect', Multiselect)
Vue.component('b-tooltip', BTooltip)
Vue.component('sliding-pagination', SlidingPagination)
Vue.filter('DateFormat', function (value) {
  if (value) {
    return moment(String(value)).utc().format('DD/MM/YYYY')
  }
})
Vue.filter('HourFormat', function (value) {
  if (value) {
    return moment(String(value)).format('HH:mm')
  }
})
Vue.filter('Week', function (value) {
  if (value) {
    return moment(String(value)).isoWeek()
  }
})
Vue.filter('WeekDuration', function (value) {
  if (value) {
    let currentDate = moment()
    let diffDate = moment(value)
    return currentDate.diff(diffDate, 'weeks')
  }
})
Vue.filter('WeekDuratByWeek', function (value) {
  if (value) {
    let currentDate = moment().isoWeek()
    let diffDate = moment(value).isoWeek()
    return Number(currentDate) - Number(diffDate)
  }
})
Vue.filter('truncate', function(text, length, clamp){
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
})
Vue.filter('toLowerCase', function (value) {
  return value.toLowerCase()
})
Vue.filter('Responsibles', function (commitment) {
  let Names = '';
  let index = 1;
  if (Array.isArray(commitment.user)) {
    let quantity = commitment.user.length;
    for (let u of commitment.user) {
      if (quantity == 1) {
        Names += u.name;
      } else {
        let aName = u.name.split(' ');
        Names += `${aName[0]}`;
      }
      if (index < quantity) {
        Names += ', ';
      }
      index++;
    }
  } else {
    Names = commitment.user.name;
  }

  return Names;
})

function cleanRut(rut) {
  return rut.replace(/[^0-9kK\-]+/g,'').toLowerCase();
}

function formatRut(rut) {
  if (rut.length > 1) {
    rut = rut.slice(0,-1)+'-'+rut.slice(-1);
  if (rut.length > 5) {
    if (rut.length > 8) {
        return rut.slice(0,-8)+'.'+rut.slice(-8,-5) +'.'+rut.slice(-5);
      }
    return rut.slice(0,-5) +'.'+rut.slice(-5);
    }
  }
  return rut
}

function defFormatRur(rut) {
  rut = rut.slice(0,-1)+'-'+rut.slice(-1);
  return rut
}

function validateRut(rut) {
  var numberRut = cleanRut(rut).slice(0,-1);
  if (numberRut.length > 6) {
    var auxArray = [2,3,4,5,6,7]
    var sum =0
    let j = 0;
    for (var i = numberRut.length - 1; i >= 0; i--) {
      if (j > 5) {
        j = 0;
      }
      sum += parseInt(numberRut[i])*auxArray[j];
      j++;
    }
    switch(11 - sum%11){
      case 11:
        return rut.slice(-1) == 0; 
      case 10:
        return rut.slice(-1) == 'k';
      default:
        return rut.slice(-1) == (11 - sum%11);
    }
  }
  return false;
}

Vue.directive('rut', {

  bind: function(el, binding, vnode) {
    var _self = binding.def.data

    for (var i = vnode.data.directives.length - 1; i >= 0; i--) {
      if (vnode.data.directives[i].name == 'model') {
        _self.vueModel = vnode.data.directives[i].expression;
        break;
      }
    }
  },
  inserted: function (el) {
    // inicializa el elemento
    el.value = ''
  },
  update: function(el, binding, vnode) {
    var _self = binding.def.data;
    // if (_self.validateRut) {
      el.value = cleanRut(el.value);
      _self.inputValue = el.value;
      if (el.value != binding.oldValue) {
        // if (validateRut(el.value)) {
          vnode.context[_self.vueModel] = cleanRut(el.value);
          _self.validateRut = false;
        // }
        // else {
        //   vnode.context[_self.vueModel] = null;
        //   _self.validateRut = false;        
        // }
      }
    // }
    // else {
    //   _self.validateRut = true;
    //   el.value = _self.inputValue;
    // }

  },
  data: {
    vueModel: '',
    inputValue: '',
    validateRut: true
  }
})

Vue.config.productionTip = false

Vue.use(Cover)
Vue.use(Vuex)
Vue.use(VueCookie)
Vue.use(VueResource)
Vue.use(VueTextareaAutosize)
Vue.use(Vuetify)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueAppend)
Vue.use(VuejsDialog);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD6L1fADkXK4pdIdJnkrXS2Mi1CSFKcDhE',
    libraries: 'places' // necessary for places input
  }
})
library.add(faAngleDown)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: {
    siderOpen: false,
  },
  sockets: {
    connect: function () {
      console.log('socket connected')
    }
  },
  router,
  store,
  render (h) {
    return (<router-view></router-view>)
  }
})



// WEBPACK FOOTER //
// ./src/main.js